import "core-js/modules/es.array.push.js";
import { reactive, toRefs, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "back-home-page",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const language = ref(sessionStorage.getItem("language"));
    const data = reactive({
      navList: [{
        id: 1,
        name: "首页",
        path: "back-index"
      }, {
        id: 4,
        name: "产品管理",
        path: "product-manage"
      }, {
        id: 2,
        name: "新闻中心",
        path: "back-new-list"
      }, {
        id: 5,
        name: "资源管理",
        path: "resource-manage"
      }, {
        id: 3,
        name: "报价咨询",
        path: "prize-consult"
      }, {
        id: 3,
        name: "会员管理",
        path: "vip-manage"
      }, {
        id: 6,
        name: "下载中心",
        path: "download-center"
      }],
      navChoose: route.name || "back-index",
      // 根据当前路由初始化
      options: [{
        name: "中文",
        value: "cn"
      }, {
        name: "英文",
        value: "en"
      }, {
        name: "日文",
        value: "jp"
      }, {
        name: "韩文",
        value: "kr"
      }]
    });
    onMounted(() => {
      // 页面加载时根据当前路由设置导航选中状态
      data.navChoose = route.name || "back-index";
    });
    const chooseNav = path => {
      data.navChoose = path;
      router.push({
        name: path
      });
    };
    const changeLanguage = value => {
      sessionStorage.setItem("language", value);
      router.go(0);
    };
    return {
      ...toRefs(data),
      chooseNav,
      language,
      changeLanguage
    };
  }
};